import axios from 'axios'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMetaStore } from '../store/MetaStore'
import PlayerLoginView from '../views/PlayerLoginView'

const PlayerLoginController = () => {
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [leagueName, setLeagueName] = useState('')
  const [loading, setLoading] = useState(false)

  const errorMsg = useMetaStore((state) => state.errorMsg)
  const setErrorMsg = useMetaStore((state) => state.setErrorMsg)
  const setOrgId = useMetaStore((state) => state.setOrgId)
  const navigate = useNavigate()

  const setCookie = (name, value, days) => {
    let expires = ''
    if (days) {
      const date = new Date()
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
      expires = '; expires=' + date.toUTCString()
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/'
  }

  const onSubmit = async () => {
    setLoading(true)
    setErrorMsg('')
    try {
      const response = await axios.post('/gskapi/golfers/login', {
        firstName,
        lastName,
        email,
        leagueName
      })

      const { golfer, orgId } = response.data

      setOrgId(orgId)

      const loginData = {
        golferId: golfer.golferId,
        golferName: golfer.golferName,
        email: golfer.email,
        orgId: orgId
      }

      setCookie('gsk_player_login', JSON.stringify(loginData), 180) // 180 days = ~6 months

      navigate('/')
    } catch (error) {
      console.error('Error logging in:', error)
      if (error.response && error.response.data && error.response.data.error) {
        setErrorMsg(error.response.data.error)
      } else {
        setErrorMsg('Login failed. Please check your credentials.')
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <PlayerLoginView
      firstName={firstName}
      setFirstName={setFirstName}
      lastName={lastName}
      setLastName={setLastName}
      email={email}
      setEmail={setEmail}
      leagueName={leagueName}
      setLeagueName={setLeagueName}
      errorMsg={errorMsg}
      setErrorMsg={setErrorMsg}
      onSubmit={onSubmit}
      loading={loading}
    />
  )
}

export default PlayerLoginController
